import React from 'react';
import t from 'react-translate';
import NvCheckbox from 'shared/components/inputs/nv-checkbox';
import { config as appConfig } from '../../../../../config/config.json';
import { config } from '../../../../../config/pendo.config.json';

export const GEN_AI_ARTICLE_LINK = `${appConfig.helpLink}/article/ART-1816`;

interface AILearningAssistantToggleProps {
  onChange: (value: boolean) => void;
  value: boolean;
}

const AILearningAssistantToggle: React.FC<AILearningAssistantToggleProps> = ({ onChange, value }) => {
  const label = t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.AI_LEARNING_ASSISTANT_TOGGLE();

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex align-items-start'>
        <div className='mt-3'>
          <NvCheckbox
            checked={value}
            onChange={(event) => onChange(event.target.checked)}
            ariaLabel={label}
            name='aiLearningAssistant'
            label=''
            dataQa={value ? config.pendo.settings.enabledAiLearning : config.pendo.settings.disabledAiLearning}
          />
        </div>
        <div className='ml-2'>
          <div>
            {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.ENABLE_AI_LEARNING_ASSISTANT(
              GEN_AI_ARTICLE_LINK,
            )}
          </div>
          <p>
            {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.PLEASE_NOTE()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AILearningAssistantToggle;
